// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ckFOkknRNkfSdNOnKlgR {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
}

.T62JCbXEKBkjpL7dDhO0 {
  top: 8.25rem;
}

.FmolwXwH6cXMoo0yzqDf {
  top: 7.75rem;
}

.QM8QCkxGGWB1JE7xYTrj {
  left: 0.9375rem;
  top: 5.75rem;
}

.J6sFHCrv3Ei48WhXsJnr.QM8QCkxGGWB1JE7xYTrj {
    top: 5.875rem;
  }

.cCW2phEVpF7l6gPmsnsG.ckFOkknRNkfSdNOnKlgR {
    width: 12.1875rem;
  }

.cCW2phEVpF7l6gPmsnsG.T62JCbXEKBkjpL7dDhO0 {
    width: 12.1875rem;
  }

.cCW2phEVpF7l6gPmsnsG.FmolwXwH6cXMoo0yzqDf {
    right: 1.625rem;
    top: 7.5rem;
  }

.cCW2phEVpF7l6gPmsnsG.QM8QCkxGGWB1JE7xYTrj {
    top: 5.9375rem;
    left: 3.125rem;
  }

.QFAuK1WDPgqSskjrevWh.ckFOkknRNkfSdNOnKlgR {
    width: 7.5rem;
  }

.QFAuK1WDPgqSskjrevWh.T62JCbXEKBkjpL7dDhO0 {
    right: 0.9375rem;
    top: 5rem;
  }

.QFAuK1WDPgqSskjrevWh.FmolwXwH6cXMoo0yzqDf {
    right: 0.9375rem;
    top: 4.5625rem;
  }

.QFAuK1WDPgqSskjrevWh.QM8QCkxGGWB1JE7xYTrj {
    top: 3.625rem;
    left: 1.875rem;
  }
`, "",{"version":3,"sources":["webpack://./src/components/HandV1/HandV1.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAU;AACZ;;AAEA;EACE,YAAU;AACZ;;AAEA;EACE,eAAU;EACV,YAAS;AACX;;AAGE;IACE,aAAS;EACX;;AAIA;IACE,iBAAY;EACd;;AAEA;IACE,iBAAY;EACd;;AAEA;IACE,eAAW;IACX,WAAU;EACZ;;AAEA;IACE,cAAS;IACT,cAAU;EACZ;;AAIA;IACE,aAAY;EACd;;AAEA;IACE,gBAAW;IACX,SAAS;EACX;;AAEA;IACE,gBAAW;IACX,cAAS;EACX;;AAEA;IACE,aAAS;IACT,cAAU;EACZ","sourcesContent":[".handContainer {\n  position: absolute;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.hand1Container {\n  top: 132px;\n}\n\n.hand2Container {\n  top: 124px;\n}\n\n.hand3Container {\n  left: 15px;\n  top: 92px;\n}\n\n.desktop-small {\n  &.hand3Container {\n    top: 94px;\n  }\n}\n\n.tablet {\n  &.handContainer {\n    width: 195px;\n  }\n\n  &.hand1Container {\n    width: 195px;\n  }\n\n  &.hand2Container {\n    right: 26px;\n    top: 120px;\n  }\n\n  &.hand3Container {\n    top: 95px;\n    left: 50px;\n  }\n}\n\n.mobile {\n  &.handContainer {\n    width: 120px;\n  }\n\n  &.hand1Container {\n    right: 15px;\n    top: 80px;\n  }\n\n  &.hand2Container {\n    right: 15px;\n    top: 73px;\n  }\n\n  &.hand3Container {\n    top: 58px;\n    left: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"handContainer": `ckFOkknRNkfSdNOnKlgR`,
	"hand1Container": `T62JCbXEKBkjpL7dDhO0`,
	"hand2Container": `FmolwXwH6cXMoo0yzqDf`,
	"hand3Container": `QM8QCkxGGWB1JE7xYTrj`,
	"desktop-small": `J6sFHCrv3Ei48WhXsJnr`,
	"tablet": `cCW2phEVpF7l6gPmsnsG`,
	"mobile": `QFAuK1WDPgqSskjrevWh`
};
export default ___CSS_LOADER_EXPORT___;
